module.exports = __webpack_public_path__ + "img/user-guide.6a5db92a.png";